<div *ngIf="viewShowing$ | async as viewShowing" class="gb-event-guest-scanner-dialog">
  <div *ngIf="viewShowing !== EventGuestScannerViewEnum.Scanner" class="gb-dialog-header">
    <h2 translate="SHARED.EVENT_TICKETS.CHECK_IN.SCANNER.HEADER" mat-dialog-title></h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <ng-container [ngSwitch]="viewShowing">
    <gb-event-guest-scanner-start *ngSwitchCase="EventGuestScannerViewEnum.Start"></gb-event-guest-scanner-start>
    <gb-event-guest-scanner-qr-code *ngSwitchCase="EventGuestScannerViewEnum.Scanner"></gb-event-guest-scanner-qr-code>
    <gb-event-guest-scanner-result *ngSwitchCase="EventGuestScannerViewEnum.Result"></gb-event-guest-scanner-result>
    <gb-event-guest-scanner-history *ngSwitchCase="EventGuestScannerViewEnum.History"></gb-event-guest-scanner-history>
  </ng-container>
</div>
